import { Helpers } from '../../helpers';
import { ICurveBuild } from '../../interfaces/icurve-build';
import { ScenarioWell } from '../scenario-well';

export class CurveBuildBase {
  CurveBuildId: number;
  Description: string;
  SortOrder: number | null;
  CurveBuildValue: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ScenarioWells_CurveBuild?: Array<ScenarioWell> | null;

  constructor(item?: ICurveBuild) {
    if (item) {

      this.CurveBuildId = item.CurveBuildId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.CurveBuildValue = item.CurveBuildValue;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ScenarioWells_CurveBuild = Helpers.createClassArray(ScenarioWell, item.ScenarioWells_CurveBuild);
    }
  }
}